<template>
  <div class="satellites">
    <v-container class="my-5">
      <v-row class="ml-1 mb-4">
        <v-col cols="12" sm="12" md="4" lg="3" class="mt-1">
          <v-text-field v-model="findTxt" hide-details outlined dense clearable label="Find" prepend-inner-icon="mdi-magnify"></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-select v-model="statusSelect" :items="statusItems" label="Status (Filter)" multiple chips hide-details clearable dense prepend-inner-icon="mdi-filter-menu" :menu-props="{ bottom: true, offsetY: true }">
            <template v-slot:selection="data">
              <v-chip :class="data.item" :key="JSON.stringify(data.item)" v-bind="data.attrs" :input-value="data.selected" @click:close="statusSelect.splice(statusSelect.indexOf(data.item), 1)" close >
                {{ data.item }}
              </v-chip>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" class="d-none d-md-block" md="4" lg="3">
          <v-select v-model="freqSelect" :items="freqItems" label="Frequency" multiple hide-details chips clearable dense prepend-inner-icon="mdi-filter-menu" :menu-props="{ bottom: true, offsetY: true }">
            <template v-slot:selection="data">
              <v-chip :class="data.item" :key="JSON.stringify(data.item)" v-bind="data.attrs" :input-value="data.selected" @click:close="freqSelect.splice(freqSelect.indexOf(data.item), 1)" close >
                {{ data.item }}
              </v-chip>
            </template>
          </v-select>
        </v-col>
      </v-row>

      <v-row class="mb-4">
        <v-col cols="12" md="3">
          <v-img
            height="150"
            contain
            src="https://static.tinygs.com/satellites/Starlink.jpg"
            alt="Generic Satellite Image"
          ></v-img>
        </v-col>
        <v-col cols="12" md="9" class="d-flex align-center">
          <p class="body-1">
            Starlink V2 satellites include a LoRa beacon that provides early orbit telemetry, tracking, and commands for the orbit-raising phase and for the unlikely event of an emergency.
          </p>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="satellites"
        :search="findTxt"
        class="elevation-1"
        item-key="name"
        @click:row="navigateToSatellite"
        :items-per-page="50"
        :footer-props="{
          'items-per-page-options': [25, 50, 100, -1]
        }"
        :loading="loadingSatellites"
        loading-text="Loading satellite data..."
        no-data-text="No satellites found matching your criteria."
        hover
        :sort-by="['confirmedPackets']"
        :sort-desc="[true]"
      >
        <template v-slot:item.confirmedPackets="{ item }">
          {{ item.confirmedPackets.toLocaleString() }}
        </template>

        <template v-slot:item.frames="{ item }">
          {{ item.frames.toLocaleString() }}
        </template>

        <template v-slot:item.lastPacketTime="{ item }">
          {{ item.lastPacketTime ? formatLaunchDate(item.lastPacketTime) : 'N/A' }}
        </template>

        <template v-slot:item.launchDate="{ item }">
          {{ item.launchDate ? formatLaunchDate(item.launchDate) : 'N/A' }}
        </template>


        <template v-slot:item.configurations="{ item }">
          {{ formatConfigurations(item.configurations) }}
        </template>

      </v-data-table>

    </v-container>
  </div>
</template>

<script>
const axios = require("axios");
import moment from 'moment'

export default {
  name: 'Satellites',
  data() {
    return {
      findTxt: "",
      statusSelect: ['SupportedSL'], // El filtro de status sigue funcionando aunque no se muestre la columna
      statusItems: ['Supported', 'Future', 'Experimental', 'Inactive'],
      freqSelect: ['137'],
      freqItems: ['137','433','868-915','2400'],
      origData: [],
      loadingSatellites: false,
      headers: [
        { text: 'Name', align: 'start', value: 'displayName', class: 'font-weight-bold' },
        { text: 'Confirmed Packets', value: 'confirmedPackets', align: 'end' },
        { text: 'Frames', value: 'frames', align: 'end' },
        { text: 'Last Packet', value: 'lastPacketTime', align: 'start' },
        { text: 'Launch Date', value: 'launchDate', align: 'start' }, // Nueva columna
        { text: 'Configurations', value: 'configurations', sortable: false, align: 'start', width: '30%' },
      ],
    }
  },
  beforeMount() {
    this.getSatellites();
  },
  methods: {
    async getSatellites() {
      this.loadingSatellites = true;
      try {
        // Simulación de llamada a API para pruebas si es necesario
        // const data = await new Promise(resolve => setTimeout(() => resolve([
        //   { name: 'SAT1', displayName: 'Satellite Alpha', confirmedPackets: 1500, frames: 200, launchDate: '2023-01-15T10:00:00Z', lastPacketTime: '2025-05-01T10:00:00Z', configurations: [{mode: 'FSK', freq: 433}], status: 'Supported' },
        //   { name: 'SAT2', displayName: 'Satellite Beta', confirmedPackets: 2500, frames: 30, launchDate: '2022-11-20T12:00:00Z', lastPacketTime: '2025-04-15T12:00:00Z', configurations: [{mode: 'LoRa', freq: 868}], status: 'Supported' },
        //   { name: 'SAT3', displayName: 'Satellite Gamma (Old)', confirmedPackets: 500, frames: 5, launchDate: '2020-01-01T00:00:00Z', lastPacketTime: '2023-01-01T00:00:00Z', configurations: [{mode: 'FSK', freq: 137}], status: 'Inactive' },
        //   { name: 'SAT4', displayName: 'Satellite Delta Future', confirmedPackets: 0, frames: 100, launchDate: '2025-12-01T00:00:00Z', lastPacketTime: null, configurations: [{mode: 'AFSK', freq: 137}], status: 'Future' },
        // ]), 1000));
        const { data } = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/v1/satellites`);
        this.origData = data;
      } catch (error) {
        console.error("Error fetching satellites:", error);
        this.origData = [];
      } finally {
        this.loadingSatellites = false;
      }
    },
    formatLaunchDate(date){ // Esta función ahora se usa para launchDate y lastPacketTime
      if (!date) return 'N/A';
      return moment(date).format('MMMM Do YYYY, H:mm:ss'); // YYYY para el año
    },
    formatConfigurations(configurations) {
      if (!configurations || configurations.length === 0) {
        return 'N/A';
      }
      return configurations.map(conf => `${conf.mode}@${conf.freq}MHz`).join(', ');
    },
    navigateToSatellite(item) {
      this.$router.push(`/satellite/${item.name}`);
    }
  },
  computed:{
    satellites(){
      if (!this.origData || this.origData.length === 0)
        return [];

      let sats = [...this.origData];

      // Filtro por frames >= 10
      sats = sats.filter(s => s.frames >= 10);

      // Filtro por lastPacketTime en los últimos 365 días
      const ninetyDaysAgo = moment().subtract(365, 'days');
      sats = sats.filter(s => {
        if (!s.lastPacketTime) return false;
        return moment(s.lastPacketTime).isAfter(ninetyDaysAgo);
      });

      // El filtro de texto 'findTxt' se pasa a :search en v-data-table.
      // Si prefieres el filtrado manual en 'displayName', 'name', 'longDescription':
      if (this.findTxt) {
         const lowerFindTxt = this.findTxt.toLowerCase();
         sats = sats.filter(s =>
            s.name.toLowerCase().includes(lowerFindTxt) ||
            s.displayName.toLowerCase().includes(lowerFindTxt) ||
            (s.longDescription && s.longDescription.toLowerCase().includes(lowerFindTxt))
        );
      }

      if (this.statusSelect.length > 0) { // El filtro por status sigue activo
        sats = sats.filter(sat => this.statusSelect.includes(sat.status))
      }

      if (this.freqSelect.length > 0) {
        sats = sats.filter(sat => {
          return this.freqSelect.some(selectedFreqValue => {
            let freq_min, freq_max;
            const selectedFreqStr = String(selectedFreqValue);

            if (selectedFreqStr === '137') {
              freq_min = 130; freq_max = 300;
            } else if (selectedFreqStr === '433') {
              freq_min = 400; freq_max = 550;
            } else if (selectedFreqStr === '868-915') {
              freq_min = 800; freq_max = 950;
            } else if (selectedFreqStr === '2400') {
              freq_min = 2100; freq_max = 2500;
            } else {
              return false;
            }
            return sat.configurations.some(conf => conf.freq > freq_min && conf.freq < freq_max);
          });
        });
      }
      return sats;
    }
  }
}

</script>

<style>
/* Estilos globales que aún pueden ser útiles */
/* .subheading { ... } */

/* Estilos para los chips de status en los filtros (ya no en la tabla) */
.Supported, .SupportedSL {
  background-color: #4CAF50 !important;
  color: black !important;
}

.Future {
  background-color: #82B1FF  !important;
  color: black !important;
}

.Experimental {
  background-color: #FFC107  !important;
  color: black !important;
}

.Inactive {
  background-color: #FF5252  !important;
  color: black !important;
}

/* Estilo para que la fila de la tabla parezca clickeable */
.v-data-table tbody tr:hover {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.05) !important;
}
</style>